import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import NavBar from './NavBar';
import Dashboard from './Dashboard';
import FormName from './FormBuilder/FormNamer';
import Form from './FormBuilder';
import FormFinder from './FormFinderBuilder';
import Submit from './FormBuilder/SubmitMessage';
import LinkedProfiles from './Dashboard/Licensees/LinkedProfiles'
import LicenseeResults from './Dashboard/Licensees/LicenseeResults'

const styles = (theme) => ({
    root: {
        display: 'flex',
    },
    content: {
        flexGrow: 1,
    },
    // necessary for content to be below app bar
    toolbar: theme.mixins.toolbar,
});

const AppContent = ({ classes }) => {
    return (
        <div className={classes.root}>
            <NavBar />
            <main className={classes.content}>
                <div className={classes.toolbar} />
                <Switch>
                    <Route path="/licenseeResults" component={LicenseeResults} />
                    <Route path="/newForm/:name" component={Form} />
                    <Route path="/formName" component={FormName} />
                    <Route path="/formFinder/:id" component={FormFinder} />
                    <Route path="/licensees/:id" component={LinkedProfiles} />
                    <Route path="/form/:id" component={Form} />
                    <Route path="/submit/:id" component={Submit} />
                    <Route path="/" component={Dashboard} />
                </Switch>
            </main>
        </div>
    );
};

export default withStyles(styles)(AppContent);
